<template>
  <div class="row my-4 mx-0 p-0">
    <div class="col-12 px-2">

      <div class="row">

        <div class="col-md-3">
          <date-picker
            id="startDatePicker"
            class=""
            v-model="form.startDate"
            :config="datePickerConfig"
            placeholder="Start Date"
          ></date-picker>
        </div>

        <div class="col-md-3">
            <date-picker
              id="endDatePicker"
              class=""
              v-model="form.endDate"
              :config="datePickerConfigEndDate"
              placeholder="End Date"
            ></date-picker>
        </div>

        <div class="col-md-3" v-if="!hasPermissions('superAdmin')">
          <treeselect
            v-model="form.ordersSelected"
            :options="listOrders"
            :multiple="true">
          </treeselect>
        </div>

         <!-- CLIENTS -->
         <div class="w-25 input-group input-group-sm p-1 treeselect-wrapper"  
         v-if="hasPermissions('superAdmin')">
              <div class="input-group-prepend">
                <span class="input-group-text" id="inputGroup-sizing-sm">
                  Clients
                </span>
              </div>
              <treeselect v-model="form.client_id" class="form-control inline-table" 
                :options="filteredClients"
                :multiple="false" 
                :searchable="true" 
                :clearable="true" 
                :loading="isLoading"
                placeholder="Search and select clients" 
                label="label" 
                track-by="id" 
                @search-change="onSearchChange">
              </treeselect>
            </div>

        <div class="col-md-3">
          <button
            class="btn-sm p-2 px-3 btn btn-success"
            @click="getActivitiesForOrder()"
            style="width: 100%"
          >
            <i class="icon-calendar-check-o mr-2"></i>
            <small>
              {{ $t("lang.button.LetsGo") }}
            </small>
          </button>
        </div>
      </div>
    </div>

    <div class="col-12 my-3" style="background-color: #D7D9F3;">
      
        <div class="row no-gutters px-1 py-4" >
          <div class="col-6 col-md d-flex">
            <div class="card flex-fill text-center m-3 p-4 rounded">
              <h5 class="font-weight-bold">Contacts</h5>
              <p class="h3 text-primary font-weight-bold">
                <Loadingcircle :paramloading="paramloading" v-if="loadingData" />
                <span v-else>{{ this.totals.new_contact_addressed }}</span>
              </p>
              <p>{{ $t("lang.label.contact_add") }}
              </p>
            </div>
          </div>

          <div class="col-6 col-md d-flex">
            <div class="card flex-fill text-center m-3 p-4 rounded">
              <h5 class="font-weight-bold">Emails</h5>
              <p class="h3 text-primary font-weight-bold">
                <Loadingcircle :paramloading="paramloading" v-if="loadingData" />
                <span v-else>{{ this.totals.follow_ups }}</span>  
              </p>
              <p>{{ $t("lang.label.tasksoliver") }}</p>
              <p>
                <span  v-if="loadingData"> - </span>
                <span v-else>{{ this.totals.manual_answer_rate }}</span>  
                % de réponses</p>              
            </div>
          </div>

          <div class="col-6 col-md d-flex">
            <div class="card flex-fill text-center m-3 p-4 rounded">
              <h5 class="font-weight-bold">{{ $t("lang.label.calls") }}</h5>
              <p class="h3 text-primary font-weight-bold">
                <Loadingcircle :paramloading="paramloading" v-if="loadingData" />
                <span v-else>{{ this.totals.appels_total }}</span>  
              </p>
              <p>{{ $t("lang.label.calls_made") }}</p>
              <p>
                <span  v-if="loadingData"> - </span>
                <span v-else>{{ this.totals.conversations }}</span>                  
                % {{ $t("lang.column.header_booker_pick_ups") }}</p>               
            </div>
          </div>

          <div class="col-6 col-md d-flex"> 
            <div class="card flex-fill text-center m-3 p-4 rounded">
              <h5 class="font-weight-bold">{{ $t("lang.label.manual_answer") }}</h5>
              <p class="h3 text-primary font-weight-bold">
                <Loadingcircle :paramloading="paramloading" v-if="loadingData" />
                <span v-else>{{ this.totals.manual_answer_total }}</span>  
              </p>
              <p>
                <span v-if="loadingData"> - </span>
                <span v-else-if="manualAnswerFollowUpsPercent !== null">{{ manualAnswerFollowUpsPercent }}%</span>
                <span v-else>—</span>
                de {{ $t("lang.label.manual_answer") }}
              </p>
            </div>
          </div>

          <div class="col-6 col-md d-flex">
            <div class="card flex-fill text-center m-3 p-4 rounded">
              <h5 class="font-weight-bold">
                {{ $t("lang.label.meeting_booked") }}
              </h5>
              <p class="h3 text-primary font-weight-bold">
                <Loadingcircle :paramloading="paramloading" v-if="loadingData" />
                <span v-else>{{ this.totals.meeting_booked }}</span>              
              </p>
              <p>
                <span  v-if="loadingData"> - </span>
                <span v-else>{{ this.totals.potential_clients  }}</span> 
                <span class="ml-1">{{ $t("lang.label.des_leads") }}</span>
              </p>                 
            </div>
          </div>          
        </div>    
      </div>

      <!-- Statistiques emails -->
      <div class="col-12 mt-3 ml-4 px-2 h5 font-weight-bold">    
        <h5 class="mt-3">
          {{ $t("lang.label.email_statistics") }}
        </h5>    
      </div>

      <div class="col-12 my-0">    

      <div class="row no-gutters px-1 py-0" >
        <div class="col-6 col-md d-flex">
          <div class="card flex-fill text-center m-3 p-4 rounded border-dark-gray">
            <h5 class="font-weight-bold">Emails envoyés</h5>
            <p class="h3 text-primary font-weight-bold">
              <Loadingcircle :paramloading="paramloading" v-if="loadingData" />
              <span v-else>{{ this.totals.follow_ups }}</span>
            </p>
            <p>{{ $t("lang.label.total_number_emails_sent") }}
            </p>
          </div>
        </div>

        <div class="col-6 col-md d-flex">
          <div class="card flex-fill text-center m-3 p-4 rounded border-dark-gray">
            <h5 class="font-weight-bold">Réponses reçues</h5>
            <p class="h3 text-primary font-weight-bold">
              <Loadingcircle :paramloading="paramloading" v-if="loadingData" />
              <span v-else>{{ this.totals.manual_answer_total }}</span>  
            </p>
            <p>{{ $t("lang.label.total_number_responses") }}</p>
              <p>
                <span  v-if="loadingData"> - </span>
                <span v-else>{{ this.totals.manual_answer_rate }}</span>  
                % de réponses</p>              
          </div>
        </div>

        <div class="col-6 col-md d-flex">
          <div class="card flex-fill text-center m-3 p-4 rounded border-dark-gray">
            <h5 class="font-weight-bold">Meetings générés</h5>
            <p class="h3 text-primary font-weight-bold">
              <Loadingcircle :paramloading="paramloading" v-if="loadingData || loadingDataCalls" />
              <span v-else>{{ this.totals.meeting_booked - this.totals.call_meetings_total }}</span>  
            </p>
            <p>{{ $t("lang.label.response_positive") }}</p>
            <p>
              <span  v-if="loadingData || loadingDataCalls"> - </span>
              <span v-else>{{ meetingsGeneratedEmailPercent }}</span>                  
              % 
              <!-- {{ $t("lang.label.answered") }} -->
            </p>               
          </div>
        </div>

        <div class="col-6 col-md d-flex">
          <div class="card flex-fill text-center m-3 p-4 rounded border-dark-gray">
            <h5 class="font-weight-bold">Rebonds</h5>
            <p class="h3 text-primary font-weight-bold">
              <Loadingcircle :paramloading="paramloading" v-if="loadingDataEmails" />
              <span v-else>{{ this.totals.bounced }}</span>  
            </p>            
            <p>
              {{ $t("lang.label.total_bounced") }}
            </p>
            <p>
              <span v-if="loadingDataEmails"> - </span>
              <span v-else-if="bounceRatePercent !== null">{{ bounceRatePercent }}%</span>
              <span v-else>—</span>
              de Rebonds
            </p>
          </div>
        </div>         
      </div>    
    </div>
    

    <!-- Tabla de datos de targets -->
    <div class="col-12 my-4">
      <div class="card flex-fill m-3 p-2 rounded border-dark-gray">
        <h5 class="font-weight-bold mt-3">
          Analyse IA des réponses par email
        </h5>
        <div v-if="loadingDataTargets" class="my-4 text-center">
          <Loadingcircle  :paramloading="paramloadingTable" />
        </div>         
        <div v-else class="mx-0 px-0 table-responsive">
          <Table
            class="mx-2 w-100" 
            :headers="headers" 
            :cols="cols" 
            :data="targetsWithTotalsRow" 
            :notselect="true"
            :key="100" 
            @openTarget="openTarget"
          />
        </div>

      </div>
    </div>

    <!-- Tabla de datos de target con calls -->
    <div class="col-12 my-4">
      <div class="card flex-fill m-3 p-2 rounded border-dark-gray">
        <h5 class="font-weight-bold mt-3">
          Bilan des appels à froid
        </h5>
        <div v-if="loadingDataTargetCalls" class="my-4 text-center">
          <Loadingcircle  :paramloading="paramloadingTable" />
        </div>         
        <div v-else class="mx-0 px-0 table-responsive">
          <Table 
            class="mx-2 w-100" 
            :headers="headersTargetCalls" 
            :cols="colsTargetCalls" 
            :data="targetCallsWithTotalsRow" 
            :notselect="true"
            :key="101" 
            @openTarget="openTarget"
          />
        </div>

      </div>
    </div>

    <!-- Graphic Email -->
    <div class="col-12 my-3 text-center">
         <h5 class="h5 font-weight-bold mt-3">
          {{ $t("lang.label.emails_conversion") }}
         </h5>

         <div v-if="loadingDataGraficoEmails" class="my-4 text-center">
          <Loadingcircle  :paramloading="paramloadingTable" />
        </div>   
        <line-chart
          v-else
          :key="emailConversionChartKey"
          :chart-data="chartData"
          :options="chartOptions"
        />
     </div>  

      <!-- Data Calls -->
      <div class="col-12 mt-3 ml-4 px-2 h5 font-weight-bold">   
        <h5 class="mt-3">
          {{ $t("lang.label.appels_statistics") }}
        </h5>     
      </div>

      <div class="col-12 my-0">    

      <div class="row no-gutters px-1 py-0" >
        <div class="col-6 col-md d-flex">
          <div class="card flex-fill text-center m-3 p-4 rounded border-dark-gray">
            <h5 class="font-weight-bold"> {{ $t("lang.label.calls_made") }}</h5>
            <p class="h3 text-primary font-weight-bold">
              <Loadingcircle :paramloading="paramloading" v-if="loadingDataCalls" />
              <span v-else>{{ this.totals.total_call_verified }}</span>
            </p>
            <p>{{ $t("lang.label.total_number_calls_made") }}
            </p>
          </div>
        </div>

        <div class="col-6 col-md d-flex">
          <div class="card flex-fill text-center m-3 p-4 rounded border-dark-gray">
            <h5 class="font-weight-bold">{{ $t("lang.label.answered_calls") }}</h5>
            <p class="h3 text-primary font-weight-bold">
              <Loadingcircle :paramloading="paramloading" v-if="loadingDataCalls" />
              <span v-else>{{ this.totals.call_conversation_total }}</span>  
            </p>
            <p>{{ $t("lang.label.number_answered_calls") }}</p>
              <p>
                <span  v-if="loadingDataCalls"> - </span>
                <span v-else>{{ this.totals.conversation_meeting_rate }}</span>  
                {{ $t("lang.label.de_response") }}</p>              
          </div>
        </div>

        <div class="col-6 col-md d-flex">
          <div class="card flex-fill text-center m-3 p-4 rounded border-dark-gray">
            <h5 class="font-weight-bold">{{ $t("lang.label.positive_contacts_per_call") }}</h5>
            <p class="h3 text-primary font-weight-bold">
              <Loadingcircle :paramloading="paramloading" v-if="loadingDataCalls" />
              <span v-else>{{ this.totals.call_meetings_total }}</span>  
            </p>
            <p>{{ $t("lang.label.interested_contacts_per_call") }}</p>
            <p>
              <span  v-if="loadingDataCalls"> - </span>
              <span v-else>{{ callMeetingsVerifiedPercent }}</span>                  
              % {{ $t("lang.label.of_calls") }}
            </p>               
          </div>
        </div>            
      </div>    
    </div>

     <!-- tasks -> hours details -->
     <div class="col-12 my-3 text-center">
       <h5 class="font-weight-bold text-left ml-3 mt-3">Répartition des appels durant la journée</h5>
         <div v-if="loadingDataHoursDetail" class="my-4 text-center">
          <Loadingcircle  :paramloading="paramloadingTable" />
        </div>   
        <CallsPerDays v-else :data="dataDays" />
        
     </div>  

     <!-- Graphic Calls -->
    <div class="col-12 my-3 text-center">         
      <h5 class="font-weight-bold text-center mt-3">Analyse IA des objections</h5>
         <div v-if="loadingDataNegativeCalls" class="my-4 text-center">
          <Loadingcircle  :paramloading="paramloadingTable" />
        </div>   
        <doughnut-chart
            v-else
            class="py-2"
            :chart-data="multiaxisOwarm"
            :options="multiaxisOwarm.options"
          />
     </div>  

    </div>  
</template>

<script>
import moment from "moment";
import Treeselect from "@riophae/vue-treeselect";
import { targetsService, monitorService } from "@/_services";
import Loadingcircle from  "@/components/Common/Loadingcircle.vue";
import Tooltip from "@/components/Common/Tooltip.vue";
import Table from "@/components/Common/Table.vue";
import LineChart from '@/components/Chart.vue'
import DoughnutChart from "@/components/DoughnutChart.vue";
import CallsPerDays from "@/components/Activity/CallsPerDays.vue";

/** Sentinel for total row so openTarget does not navigate (Table emit uses truthy emit id). */
const ACTIVITY_TABLE_TOTAL_EMIT_ID = "__ACTIVITY_TABLE_TOTAL_ROW__";

export default {
  name: 'Activity',
  components: {
    Treeselect, Loadingcircle, Tooltip, Table, LineChart, CallsPerDays, DoughnutChart
  },
  created(){

    //si el user actual es tipo SuperAdmin
    if(!this.hasPermissions('superAdmin')) {
      this.getOrders();      
    } else {
      this.getClients();      
    }
  },
  data() {
    return {
        filteredClients: [],
        clients: [],
        isLoading: false,
        dataDays: [],
        chartOptions: {
          responsive: true,
          maintainAspectRatio: false,
          scales: {
            yAxes: [
              {
                id: 'y-axis-1',
                type: 'linear',
                position: 'left',
                ticks: { beginAtZero: true },
                scaleLabel: {
                  display: true,
                  labelString: 'Nombre de courriels'
                }
              },
              {
                id: 'y-axis-2',
                type: 'linear',
                position: 'right',
                ticks: {
                  beginAtZero: true,
                  min: 0,
                  max: 100,
                },
                scaleLabel: {
                  display: true,
                  labelString: 'Taux de conversion (%)'
                },
                gridLines: {
                  drawOnChartArea: false
                }
              }
            ],
            xAxes: [{
              type: 'time',
              time: {
                unit: 'day',
                tooltipFormat: 'YYYY-MM-DD'
              },
              distribution: 'series'
            }]
          },
          legend: {
            position: 'top'
          }
        },      
        chartOptionsCalls: {
          responsive: true,
          maintainAspectRatio: false,
          scales: {
            yAxes: [
              {
                id: 'y-axis-1',
                type: 'linear',
                position: 'left',
                ticks: { beginAtZero: true },
                scaleLabel: {
                  display: true,
                  labelString: 'Nombre de courriels'
                }
              },
              {
                id: 'y-axis-2',
                type: 'linear',
                position: 'right',
                ticks: {
                  beginAtZero: true,
                  max: 100
                },
                scaleLabel: {
                  display: true,
                  labelString: 'Taux de conversion (%)'
                },
                gridLines: {
                  drawOnChartArea: false
                }
              }
            ],
            xAxes: [{
              type: 'time',
              time: {
                unit: 'day',
                tooltipFormat: 'YYYY-MM-DD'
              },
              distribution: 'series'
            }]
          },
          legend: {
            position: 'top'
          }
      },  
      chartData: {
        "labels": [],
        "datasets": [
          {
            "label": "Emails envoyés",
            "type": "bar",
            "backgroundColor": "rgba(173, 216, 230, 0.5)",  // celeste claro
            "data": []
          },
          {
            "label": "Réponses reçues",
            "type": "bar",
            "backgroundColor": "rgba(255, 182, 193, 0.5)",  // rosa claro
            "data": []
          },
          {
            "label": "Taux de conversion (%)",
            "type": "line",
            "borderColor": "#007bff",
            "fill": false,
            "yAxisID": "y-axis-2",
            "data": []
          }
        ]
      },
      emailConversionChartKey: 0,
      chartDataCalls: {
        "labels": [],
        "datasets": [
          {
            "label": "Appels passés",
            "type": "bar",
            "backgroundColor": "rgba(173, 216, 230, 0.5)",  // celeste claro
            "data": []
          },
          {
            "label": "Appels décrochés",
            "type": "bar",
            "backgroundColor": "rgba(255, 182, 193, 0.5)",  // rosa claro
            "data": []
          },
          {
            "label": "Taux de conversion (%)",
            "type": "line",
            "borderColor": "#007bff",
            "fill": false,
            "yAxisID": "y-axis-2",
            "data": []
          }
        ]
      },    
      multiaxisOwarm: {
        labels: [
          "No need",
          "Not the right person",
          "Already with competitor",
          "No pitch",
          "Other",
          "Not the moment"
        ],
        datasets: [
          {
            backgroundColor: [
              "#9FF0FF",
              "#E1FAE9",
              "#85EDA8",
              "#0BDA51",
              "#EAEAEA",
              "#CDCDCD",
            ],
            data: []
          },
        ],
        options: {
          cutoutPercentage: 30,
          responsive: true,
          aspectRatio: 1,
          maintainAspectRatio: false,
          devicePixelRatio: 2,
          title: {
            display: true,
            text: "NEGATIVE CALLS",
            innerText: "calls",
          },
          legend: {
            position: 'right',
            display: true,            
            fontSize: 16,
            // fontColor: '#000',           
          },
          tooltips: {
            callbacks: {
              label: function (tooltipItem, data) {
                var dataset = data.datasets[tooltipItem.datasetIndex];
                var value = dataset.data[tooltipItem.index];
                var total = dataset.data.reduce(function (a, b) {
                  return a + (Number(b) || 0);
                }, 0);
                var pct = total ? ((Number(value) || 0) / total * 100).toFixed(2) : "0.00";
                var label = data.labels[tooltipItem.index] || "";
                if (value === undefined || value === null) return label;
                return label + ": " + value + " (" + pct + "%)";
              },
            },
          },
        },
      },
      paramloading: {
        width: '28px',
        height: '28px',
        color: '#5054EB'
      },
      paramloadingTable: {
        width: '58px',
        height: '58px',
        color: '#5054EB'
      },
      form:{
        startDate: moment().startOf('month').format("YYYY-MM-DD"),
        endDate: moment().format("YYYY-MM-DD"),
        ordersSelected: [],
        client_id: null
      },
      listOrders: null,
      totals: {
        meeting_booked: 0,
        new_contact_addressed: 0,
        follow_ups: 0,
        clic_on_agenda: 0,
        ongoing_conversations: 0,
        ongoing_meeting_reschduling: 0,
        appels_total: 0,
        manual_answer_total: 0,
        manual_answer_total_positive: 0,
        meeting_generated: 0,
        bounced: 0,
        total_call_verified: 0,
        call_conversation_total: 0,
        call_meetings_total: 0,
        conversations: 0,
        potential_clients: 0,
        manual_answer_rate: 0,
        conversation_meeting_rate: 0,
      },
      loadingData: false,
      loadingDataTargets: false,
      loadingDataGraficoEmails: false,
      loadingDataHoursDetail: false,
      loadingDataGraphicCalls: false,
      loadingDataNegativeCalls: false,
      loadingDataTargetCalls: false,
      loadingDataEmails: false,
      loadingDataCalls: false,
      datePickerConfig: {
        format: "YYYY-MM-DD",
        useCurrent: false,
        // minDate: moment().startOf("day")
        maxDate: moment().endOf("day"),
      },
      datePickerConfigEndDate: {
        format: "YYYY-MM-DD",
        useCurrent: false,
        maxDate: moment().endOf("day"),
      },
      targets: [],
      targetCalls:[],
      headers: [
        {
          label: 'Target',
          percentage: "0.1%",
          class: "overflowhide",          
          id: 1,
        },
        {
          label: this.$t("lang.label.contacts"),
          percentage: "0.1%",
          class: "overflowhide",          
          id: 2,
        },
        {
          label: this.$t("lang.label.tasksoliver"),
          percentage: "0.1%",
          class: "overflowhide",          
          id: 3,
        },
        {
          label: this.$t("lang.column.replies"),
          percentage: "0.1%",
          class: "overflowhide",          
          id: 4,
        },
        {
          label: this.$t("lang.column.positive"),
          percentage: "0.1%",
          class: "overflowhide",          
          id: 5,
        },
        {
          label: this.$t("lang.column.introduction"),
          percentage: "0.1%",
          class: "overflowhide",          
          id: 6,
        },
        {
          label: this.$t("lang.column.not_interested"),
          percentage: "0.1%",
          class: "overflowhide",          
          id: 7,
        },
        {
          label: this.$t("lang.column.out_of_target"),
          percentage: "0.1%",
          class: "overflowhide",          
          id: 8,
        },
        {
          label: this.$t("lang.column.wrong_person"),
          percentage: "0.1%",
          class: "overflowhide",          
          id: 9,
        },
        {
          label: this.$t("lang.column.do_not_contact_anymore"),
          percentage: "0.1%",
          class: "overflowhide",          
          id: 10,
        },
        {
          label: this.$t("lang.column.not_followed_up"),
          percentage: "0.1%",
          class: "overflowhide",          
          id: 11,
        },
      ],
      headersTargetCalls: [
        {
          label: 'Target',
          percentage: "10%",
          class: "overflowhide",          
          id: 1,
        },
        {
          label: 'Total Calls',
          percentage: "8%",
          class: "overflowhide",          
          id: 2,
        },
        {
          label: 'Appels décrochés',
          percentage: "8%",
          class: "overflowhide",          
          id: 3,
        },
        {
          label: 'Réunion programmée',
          percentage: "8%",
          class: "overflowhide",          
          id: 4,
        },
        {
          label: 'Pas de réponse',
          percentage: "8%",
          class: "overflowhide",          
          id: 5,
        },
        {
          label: 'Demande de rappel',
          percentage: "8%",
          class: "overflowhide",          
          id: 6,
        },
        {
          label: 'Pas de téléphone',
          percentage: "8%",
          class: "overflowhide",          
          id: 7,
        },
        {
          label: 'Neutre',
          percentage: "8%",
          class: "overflowhide",          
          id: 8,
        },
        {
          label: 'Contact hors périmètre',
          percentage: "8%",
          class: "overflowhide",          
          id: 9,
        },
        {
          label: 'Entreprise hors périmètre',
          percentage: "8%",
          class: "overflowhide",          
          id: 10,
        },
        {
          label: 'Mauvais numéro',
          percentage: "8%",
          class: "overflowhide",          
          id: 11,
        },
        {
          label: 'Pas intéressé',
          percentage: "8%",
          class: "overflowhide",          
          id: 12,
        },
        {
          label: 'Pas de besoin',
          percentage: "8%",
          class: "overflowhide",          
          id: 13,
        },
        {
          label: 'Vide',
          percentage: "8%",
          class: "overflowhide",          
          id: 14,
        },
        {
          label: 'Pas la bonne personne',
          percentage: "8%",
          class: "overflowhide",          
          id: 15,
        },
        {
          label: 'Autre',
          percentage: "8%",
          class: "overflowhide",          
          id: 16,
        },
        {
          label: 'Mauvais moment',
          percentage: "8%",
          class: "overflowhide",          
          id: 17,
        },
        {
          label: 'Pas de pitch',
          percentage: "8%",
          class: "overflowhide",          
          id: 18,
        },
        {
          label: 'Déjà équipé',
          percentage: "8%",
          class: "overflowhide",          
          id: 19,
        },
      ],
      cols: [
        [
          {
            value_label: "target_name",
            value_emit: "target_id",
            class: "text-primary",
            textShort: 40,
            type: "emit",
            emit: "openTarget",
          }
        ],
        [
          {
            value: "new_contact_addressed_total",         
          }
        ],
        [
          {
            value: "follow_ups_total",
          }
        ],
        [
          {
            value: "total_sent",
          }        
        ],
        [
          {
            value: "er_positive",
          }
        ],
        [
          {
            value: "er_introduction",
          }
        ],
        [
         {
            value: "er_negative",
          }
        ],
        [  
          {
            value: "er_notscope",
          },
        ],
        [
          {
            value: "er_wrong",
          }
        ],
        [
          {
            value: "er_donotcontact",
          }
        ],
        [
          {
            value: "er_unknown",
          },
        ],
      ],
      colsTargetCalls: [
        [
          {
            value_label: "name",
            value_emit: "id",
            class: "text-primary",
            textShort: 40,
            type: "emit",
            emit: "openTarget",
          }
        ],
        [
          {
            value: "total_calls",         
          }
        ],
        [
          {
            value: "total_calls_answered",
          }
        ],
        [
          {
            value: "total_calls_meeting_booked",
          }        
        ],
        [
          {
            value: "total_calls_no_answered",
          }
        ],
        [
          {
            value: "total_calls_call_back",
          }
        ],
        [
         {
            value: "total_calls_no_phone",
          }
        ],
        [  
          {
            value: "total_calls_neutral",
          },
        ],
        [
          {
            value: "total_calls_out_of_scope_contact",
          }
        ],
        [
          {
            value: "total_calls_out_of_scope_company",
          }
        ],
        [
          {
            value: "total_calls_bad_number",
          }
        ],
        [
          {
            value: "total_calls_not_interest",
          }
        ],
        [
          {
            value: "transcription_no_need",
          }
        ],
        [
          {
            value: "transcription_not_the_right_person",
          }
        ],
        [
          {
            value: "transcription_other",
          }
        ],
        [
          {
            value: "transcription_not_the_moment",
          }
        ],
        [
          {
            value: "transcription_no_pitch",
          }
        ],
        [
          {
            value: "transcription_already_with_competitor",
          }
        ],
      ],
    };
  },
  computed: {
    bounceRatePercent() {
      const bounced = Number(this.totals.bounced);
      const followUps = Number(this.totals.follow_ups);
      if (
        Number.isNaN(bounced)
        || Number.isNaN(followUps)
        || followUps <= 0
      ) {
        return null;
      }
      return ((bounced / followUps) * 100).toFixed(2);
    },
    manualAnswerFollowUpsPercent() {
      const manual = Number(this.totals.manual_answer_total);
      const followUps = Number(this.totals.follow_ups);
      if (
        Number.isNaN(manual)
        || Number.isNaN(followUps)
        || followUps <= 0
      ) {
        return null;
      }
      return ((manual / followUps) * 100).toFixed(2);
    },
    meetingsGeneratedEmailPercent() {
      const booked = Number(this.totals.meeting_booked);
      const callMeetings = Number(this.totals.call_meetings_total);
      const addressed = Number(this.totals.new_contact_addressed);
      if (
        Number.isNaN(booked)
        || Number.isNaN(callMeetings)
        || Number.isNaN(addressed)
        || addressed <= 0
      ) {
        return 0;
      }
      const pct = ((booked - callMeetings) / addressed) * 100;
      if (pct > 0) {
        return pct.toFixed(2);
      }
      return 0;
    },
    callMeetingsVerifiedPercent() {
      const verified = Number(this.totals.total_call_verified);
      const meetings = Number(this.totals.call_meetings_total);
      if (
        !Number.isFinite(verified)
        || !Number.isFinite(meetings)
        || verified <= 0
      ) {
        return 0;
      }
      return ((meetings / verified) * 100).toFixed(2);
    },
    targetsWithTotalsRow() {
      const sumKeys = [
        "new_contact_addressed_total",
        "follow_ups_total",
        "total_sent",
        "er_positive",
        "er_introduction",
        "er_negative",
        "er_notscope",
        "er_wrong",
        "er_donotcontact",
        "er_unknown",
      ];
      const rows = (this.targets || []).filter((r) => !r.totalRow);
      if (!rows.length) {
        return this.targets || [];
      }
      const totals = {};
      sumKeys.forEach((key) => {
        totals[key] = rows.reduce(
          (sum, row) => sum + this.parseActivityCountCell(row[key]),
          0
        );
      });
      return [
        ...rows,
        {
          totalRow: true,
          target_name: "Total",
          target_id: ACTIVITY_TABLE_TOTAL_EMIT_ID,
          ...totals,
        },
      ];
    },
    targetCallsWithTotalsRow() {
      const sumKeys = [
        "total_calls",
        "total_calls_answered",
        "total_calls_meeting_booked",
        "total_calls_no_answered",
        "total_calls_call_back",
        "total_calls_no_phone",
        "total_calls_neutral",
        "total_calls_out_of_scope_contact",
        "total_calls_out_of_scope_company",
        "total_calls_bad_number",
        "total_calls_not_interest",
        "transcription_no_need",
        "transcription_not_the_right_person",
        "transcription_other",
        "transcription_not_the_moment",
        "transcription_no_pitch",
        "transcription_already_with_competitor",
      ];
      const rows = (this.targetCalls || []).filter((r) => !r.totalRow);
      if (!rows.length) {
        return this.targetCalls || [];
      }
      const totals = {};
      sumKeys.forEach((key) => {
        totals[key] = rows.reduce(
          (sum, row) => sum + this.parseActivityCountCell(row[key]),
          0
        );
      });
      return [
        ...rows,
        {
          totalRow: true,
          name: "Total",
          id: ACTIVITY_TABLE_TOTAL_EMIT_ID,
          ...totals,
        },
      ];
    },
  },
  mounted() {
      //si el user actual es tipo SuperAdmin
      if(!this.hasPermissions('superAdmin')) {
        this.getTotals();
      }
    
  },
  methods: {
    onSearchChange(searchQuery) {
      if (searchQuery.length > 1) {
        const query = searchQuery.toLowerCase();
        this.filteredClients = this.clients.filter((client) =>
          client.label.toLowerCase().includes(query)
        );
      } else {
        this.filteredClients = []
      }
    },
    getClients() {
      const toCreateUser = 1;
      const subscriptionPlanVersion = 5;
      monitorService.getClients(null, "2,3,4,5,9", toCreateUser, subscriptionPlanVersion)
        .then(res => {
          this.clients = res
          // if (this.filters.client) {
          //   this.filteredClients = this.clients.filter(client => client.id == this.filters.client)
          // }
        })
        .catch(err => console.log(err));
    },
    hasPermissions(perm) {
      if (!this.$store.getters["authentication/hasPermissions"]) {
        return false;
      }
      return this.$store.getters["authentication/hasPermissions"](perm);
    },
    getDataDays(){
      const data = [];

        for (let dayIndex = 0; dayIndex < 7; dayIndex++) {
          for (let hour = 0; hour < 24; hour++) {
            data.push({
              dayIndex,
              hour,
              value: Math.floor(Math.random() * 101), // valores de 0 a 100
              category: "Positif",
            });
          }
        }

        return data;

    },
    openTarget(order_id) {
      if (order_id === ACTIVITY_TABLE_TOTAL_EMIT_ID) {
        return;
      }
      let url = "/orders/" + order_id;
      window.open(url, "_blank");
    },
    /**
     * Sums only the leading numeric part of cells like "12 (5.2%)"; ignores the percentage in totals.
     */
    parseActivityCountCell(val) {
      if (val == null || val === "") {
        return 0;
      }
      if (typeof val === "number" && !Number.isNaN(val)) {
        return val;
      }
      let s = String(val).trim();
      const paren = s.indexOf("(");
      if (paren !== -1) {
        s = s.slice(0, paren).trim();
      }
      s = s.replace(/\s/g, "").replace(",", ".");
      const n = parseFloat(s);
      return Number.isNaN(n) ? 0 : n;
    },
    normalizeConversionRatePoints(raw) {
      if (!raw || !Array.isArray(raw)) {
        return [];
      }
      const out = [];
      for (const p of raw) {
        if (p == null) {
          continue;
        }
        if (typeof p === "number") {
          if (Number.isFinite(p)) {
            out.push(p);
          }
          continue;
        }
        if (typeof p === "object") {
          const y =
            p.y != null
              ? Number(p.y)
              : p.v != null
                ? Number(p.v)
                : NaN;
          if (Number.isFinite(y)) {
            out.push(y);
          }
        }
      }
      return out;
    },
    syncEmailChartConversionAxisTicks(conversionRate) {
      const yAxes = this.chartOptions.scales.yAxes;
      const axis2 = yAxes.find((a) => a.id === "y-axis-2");
      if (!axis2 || !axis2.ticks) {
        return;
      }
      const ticks = axis2.ticks;
      const values = this.normalizeConversionRatePoints(conversionRate);
      ticks.beginAtZero = true;
      ticks.min = 0;
      if (!values.length) {
        ticks.max = 100;
        return;
      }
      const maxVal = Math.max(...values);
      if (!Number.isFinite(maxVal) || maxVal <= 0) {
        ticks.max = 100;
        return;
      }
      let max = maxVal * 1.15;
      max = Math.min(100, max);
      if (maxVal < 10) {
        max = Math.min(100, Math.max(max, maxVal + 1));
      }
      ticks.max = max;
    },
    getActivitiesForOrder(){
      this.loadingData = true;
      const data = {
        client_id: this.form.client_id ? this.form.client_id : 0,
        startDate: this.form.startDate,
        endDate: this.form.endDate,
        target_ids: ( this.form.ordersSelected.length > 0 ) ? this.form.ordersSelected.map( target => target ).join() : 0
      }

      this.totals.conversations = 0;
      this.totals.potential_clients = 0;
      this.totals.manual_answer_rate = 0;

      targetsService.getActivitiesForOrder(data)
      .then(res => {
        this.totals.new_contact_addressed = res.new_contact_addressed_total;
        this.totals.follow_ups = res.follow_ups_total;        
        this.totals.meeting_booked = res.meeting_booked_total;
        this.totals.appels_total = res.appels_total;
        this.totals.manual_answer_total = res.manual_answer_total;
        this.totals.conversations = ((res.call_conversation_total / res.appels_total) * 100).toFixed(2);
        this.totals.potential_clients = ((res.meeting_booked_total / res.new_contact_addressed_total ) * 100 ).toFixed(2);
        this.totals.manual_answer_rate = res.manual_answer_rate;     

        this.loadingData = false
      })

      let dataItem = 2 // pido dataos para tabla de ordenes
      this.loadingDataEmails = true
      targetsService.getActivitiesForOrder(data, dataItem)
      .then(res => {      

        this.totals.bounced = res.bounced;        
        //this.totals.manual_answer_total_positive = res.manual_answer_total_positive;      
        this.totals.meeting_generated = res.meeting_generated;        

        this.loadingDataEmails = false
      })


      this.loadingDataTargets = true;

      dataItem = 3
      targetsService.getActivitiesForOrder(data, dataItem)
      .then(res => {
        this.targets = res.data;
        this.loadingDataTargets = false;
      })


      this.loadingDataGraficoEmails = true;
      dataItem = 4 // grafico emails
      targetsService.getActivitiesForOrder(data, dataItem)
      .then(res => {
        this.chartData.labels = res.data.labels;
        this.chartData.datasets[0].data = res.data.emailsSent;
        this.chartData.datasets[1].data = res.data.responsesReceived;
        this.chartData.datasets[2].data = res.data.conversionRate;
        this.syncEmailChartConversionAxisTicks(res.data.conversionRate);
        this.emailConversionChartKey += 1;

        this.loadingDataGraficoEmails = false;
      })


      //Get data de llamadas 
      this.loadingDataCalls = true;
      dataItem = 5 // calls
      targetsService.getActivitiesForOrder(data, dataItem)
      .then(res => {
        this.totals.total_call_verified = res.total_call_verified;
        this.totals.call_conversation_total = res.call_conversation_total
        this.totals.call_meetings_total = res.call_meetings_total
        this.totals.conversation_meeting_rate = (res.call_conversation_total / res.total_call_verified * 100).toFixed(2)
        this.loadingDataCalls = false;
      })


       //Get data de llamadas por hora 
      this.loadingDataHoursDetail = true;
      dataItem = 6 // calls por hora
      targetsService.getActivitiesForOrder(data, dataItem)
        .then(res => {
          this.dataDays = res.data.map(item => ({
              dayIndex: parseInt(item.dayIndex),
              hour: parseInt(item.hour),
              value: parseInt(item.value),
              category: item.category
            }));

          this.loadingDataHoursDetail = false;
      })

      this.loadingDataGraphicCalls = true;
      dataItem = 7 // grafico calls
      targetsService.getActivitiesForOrder(data, dataItem)
      .then(res => {
        this.chartDataCalls.labels = res.data.labels;
        this.chartDataCalls.datasets[0].data = res.data.callData;
        this.chartDataCalls.datasets[1].data = res.data.callConversations;
        this.chartDataCalls.datasets[2].data = res.data.conversionRate;

        this.loadingDataGraphicCalls = false;
      })


      this.loadingDataNegativeCalls = true
      dataItem = 8 // negative calls
      targetsService.getActivitiesForOrder(data, dataItem)
      .then(res => {

        this.multiaxisOwarm.datasets[0].data = res.data.negativeCalls
          .filter(item => item.item !== 'empty')
          .map(item => parseInt(item.total));

        if (this.multiaxisOwarm.datasets[0].data.length > 0) {
          const total = this.multiaxisOwarm.datasets[0].data.reduce((a, b) => a + b, 0);
          this.multiaxisOwarm.options.title.text =
            "Objections (réponse négatives) = TOTAL: " + total;
        }
        
        this.loadingDataNegativeCalls = false;
      })

      this.loadingDataTargetCalls = true;
      dataItem = 9 // target calls
      targetsService.getActivitiesForOrder(data, dataItem)
      .then(res => {        
        this.targetCalls = res.data.targetCalls;
        this.loadingDataTargetCalls = false;
      })


    },
    getOrders () {
      targetsService.getAll().then(response => {
        if (response.length > 0) {

          this.listOrders = response.map( el => ({id: el.id, label: (el.target_status_id ==4 ? '[Active] ' : '[Inactive] ') + el.name  }));
        }
      });
    },
    loadOrders(){
      const load = (this.listOrders.length === 0) ? false : true;
      return load;
    },
    getTotals(){
      this.totals = {
        meeting_booked: 0,
        new_contact_addressed: 0,
        follow_ups: 0,
        clic_on_agenda: 0,
        ongoing_conversations: 0,
        ongoing_meeting_reschduling: 0,
        appels_total: 0,
        manual_answer_total: 0,
        manual_answer_total_positive: 0,
        meeting_generated: 0,
        bounced: 0,
        total_call_verified: 0,
        call_conversation_total: 0,
        call_meetings_total: 0,
        conversations: 0,
        potential_clients: 0,
        manual_answer_rate: 0,
        conversation_meeting_rate: 0,
      }
    },
    getsentrate() {
      //this.stats.activity.emails_sent - this.stats.activity.bounce_total,
      //this.stats.activity.emails_sent
      return this.getPercentage(22,11 );
    },
  },
};
</script>

<style scoped>
.circle {
  width: 15px;
  height: 15px;
  border-radius: 50%;
  font-size: 11px;
  margin: 0px;
}

.border-dark-gray {
  border: 1px solid #CDC9C9; /* un gris más oscuro */
}
</style>
